import { z } from 'zod'

export const TrackingRequestSchema = z.object({
  user_agent: z.string().nullable().optional(),
  referer: z.string().nullable().optional(),
  client_ip: z.string().nullable().optional(),
  longitude: z.string().nullable().optional(),
  latitude: z.string().nullable().optional(),
  locale: z.string().nullable().optional(),
  lang: z.string().nullable().optional(),
  platform: z.string().nullable().optional(),
  browser: z.string().nullable().optional(),
  browser_version: z.string().nullable().optional(),
  page: z.string().nullable().optional(),
  optional_data: z.string().nullable().optional(),
})

export const TrackingResponseSchema = z.object({
  status: z.string(),
})

export type TrackingRequest = z.infer<typeof TrackingRequestSchema>
export type TrackingResponse = z.infer<typeof TrackingResponseSchema>
